import {AbstractModel} from './abstract-model';
import {Site} from './site/site';
import {Product} from './product';
import {Offer} from './offer';
import {Partner} from './partner/partner';
import {LandingPage} from './landing-page/landing-page';

export class Lead extends AbstractModel {
  id: number | null = null;
  createdAt: Date | null = null;
  site: Site | null = null;
  email: string | null = null;
  firstname: string | null = null;
  wish: string | null = null;
  country: string | null = null;
  language: string | null = null;
  gender: string | null = null;
  birthdate: string | null = null;
  birthPlace: string | null = null;
  birthPlaceId: string | null = null;
  coreg: string | null = null;
  cross: string | null = null;
  cid: number | null = null;
  leadUpStatusCode: number | null = null;
  leadUpResponse: string | null = null;
  leadUpTime: number | null = null;
  subid: string | null = null;
  tc1: string | null = null;
  tc2: string | null = null;
  tc3: string | null = null;
  tc4: string | null = null;
  clickid: string | null = null;
  ip: string | null = null;
  sourceTypology: string | null = null;
  sourceType: string | null = null;
  sourceDetails: any | null = null;
  fingerprint: any | null = null;
  fingerprintSent: boolean = false;
  product: Product | null = null;
  offer: Offer | null = null;
  partner: Partner | null = null;
  landingPage: LandingPage | null = null;
  succeeded: boolean | null = null;
  doi: boolean | null = null;
  bot: boolean | null = null;
  reactivated: boolean | null = null;
  alreadyRegistered: boolean | null = null;
  consent: boolean | null = null;
  cost: number | null = null;
  skipAr: boolean = false;
  uniqueReference: string | null = null;

  override deserialize(input: any): this {
    super.deserialize(input);

    if (input.product) {
      this.product = new Product().deserialize(input.product);
    }

    if (input.offer) {
      this.offer = new Offer().deserialize(input.offer);
    }

    if (input.partner) {
      this.partner = new Partner().deserialize(input.partner);
    }

    if (input.landingPage) {
      this.landingPage = new LandingPage().deserialize(input.landingPage);
    }

    return this;
  }
}
